<template>
	<b-row class="align-items-center justify-content-end">
		<b-col cols="3" class="text-right">
			<label for="case-assigned-to" class="mb-0">Case Assigned To</label>
		</b-col>
		<b-col cols="5">
			<b-input-group
				id="case-assigned-to"
				title="Assign case to user"
			>
				<b-input-group-addon is-text>
					<font-awesome-icon v-if="assigning" icon="circle-notch" fixed-width spin />
					<font-awesome-icon v-else icon="user" fixed-width />
				</b-input-group-addon>
				<b-form-select
					name="case_assigned_to"
					v-if="canAssign"
					v-model="caseEntity.assigned_to"
					required="required"
					:disabled="inputDisabled"
					@change="assign"
				>
		                   <option :value="null">(Unassigned - Open Queue)</option>
                         	<option
								v-for="user in users"
								:key="user.id"
								:value="user.id"
								:disabled="!user.active"
							>
								{{ user.full_name }} <span v-if="!user.active">(Inactive)</span>
							</option>
				</b-form-select>
				<b-form-input
					v-else
					type="text"
					:readonly="true"
					:value="caseEntity.assigned_to_user ? caseEntity.assigned_to_user.full_name : '(Open Queue)'"
				/>
			</b-input-group>
		</b-col>
	</b-row>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";

export default {
	name: "AssignCase",
	props: {
		caseEntity: {
			type: Object,
			default: () => {
				return {
					id: null,
					assigned: null,
					assigned_to: null,
					assigned_to_user: null,
				};
			},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		canAssign() {
			if (this.caseEntity.completed) {
				return false;
			}

			return true;
		},
		currentlyAssignedTo() {
			if (this.caseEntity.assigned_to_user && this.caseEntity.assigned_to_user.id) {
				return this.caseEntity.assigned_to_user.id;
			}

			return false;
		},
		inputDisabled() {
			if (this.disabled) return true;
			if (this.assigning) return true;
			if (!this.users || !this.users.length > 0) return true;

			return false;
		},
		...mapGetters({
			users: "users/active",
			loadingUsers: "users/loadingActive",
		}),
	},
	data() {
		return {
			assigning: false,
			assignedTo: null,
			changeAssignToForAppealID:null,
			lastCaseAssignedToUserID:null
		};
	},
	mounted() {
		this.assignedTo = this.caseEntity.assigned_to;
	},
	methods: {
		async assign() {
			try {
				this.assigning = true;

				if(this.checkAppealsAndRequestsAssignChange()){
					for(let i=0;i<this.caseEntity.case_requests.length;i++){
						if(this.caseEntity.case_requests[i].appeal_id === this.changeAssignToForAppealID){
							const response = await this.$store.dispatch("caseRequests/assign", {
								id: this.caseEntity.case_requests[i].id,
								case_id: this.caseEntity.assigned_to,
								user_id: this.caseEntity.assigned_to,
							});
						}
					}
					const response = await this.$store.dispatch("appeals/assign", {
						id: this.changeAssignToForAppealID,
						user_id: this.caseEntity.assigned_to,
					});
				}
				
				const response = await this.$store.dispatch("cases/assign", {
					id: this.caseEntity.id,
					user_id: this.caseEntity.assigned_to,
				});
				this.assignedTo = response.assigned_to;
				this.caseEntity.assigned_to = response.assigned_to;
				
				this.$emit("assigned", response);

				if (response.assigned_to_user && response.assigned_to_user.full_name) {
					this.$store.dispatch("notify", {
						title: "Case Assigned",
						message: `Case reassigned to ${response.assigned_to_user.full_name}.`,
						variant: "primary",
					});
				} else {
					this.$store.dispatch("notify", {
						title: "Case Unassigned",
						message: `Case was unassigned and returned to the open queue.`,
						variant: "primary",
					});
				}
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Assign Failed",
					message: "Failed to reassign case.",
				});
			} finally {
				this.assigning = false;
			}
		},
		checkAppealsAndRequestsAssignChange(){
			
			for(let i=0;i<this.caseEntity.appeals.length;i++){
				if (
						(this.caseEntity.assigned_to_user && this.caseEntity.assigned_to_user.active === false) &&
						(this.caseEntity.appeals[i].assigned_to_user && this.caseEntity.appeals[i].assigned_to_user.active === false) &&
						(this.lastCaseAssignedToUserID === this.caseEntity.appeals[i].assigned_to) &&
						this.caseEntity.appeals[i].appeal_status !== 'Closed'
					) {
					this.changeAssignToForAppealID = this.caseEntity.appeals[i].id;
					
					return true;
				}
			}
			return false;
		}
	},
	watch: {
		'caseEntity.assigned_to': function(newValue, oldValue) {
			
			this.lastCaseAssignedToUserID = oldValue;
		}
	}
};
</script>
